import { render, staticRenderFns } from "./CPBooks.vue?vue&type=template&id=26054610&"
import script from "./CPBooks.vue?vue&type=script&lang=js&"
export * from "./CPBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports